var map = {
	"./asia": 716,
	"./asia.js": 716,
	"./australia": 718,
	"./australia.js": 718,
	"./cricinfo/africa": 617,
	"./cricinfo/africa.js": 617,
	"./cricinfo/australia": 706,
	"./cricinfo/australia.js": 706,
	"./cricinfo/bangladesh": 707,
	"./cricinfo/bangladesh.js": 707,
	"./cricinfo/global": 708,
	"./cricinfo/global.js": 708,
	"./cricinfo/india": 709,
	"./cricinfo/india.js": 709,
	"./cricinfo/newzealand": 710,
	"./cricinfo/newzealand.js": 710,
	"./cricinfo/pakistan": 711,
	"./cricinfo/pakistan.js": 711,
	"./cricinfo/srilanka": 712,
	"./cricinfo/srilanka.js": 712,
	"./cricinfo/taboola": 704,
	"./cricinfo/taboola.js": 704,
	"./cricinfo/unitedkingdom": 713,
	"./cricinfo/unitedkingdom.js": 713,
	"./cricinfo/unitedstates": 714,
	"./cricinfo/unitedstates.js": 714,
	"./en-global": 719,
	"./en-global.js": 719,
	"./india": 720,
	"./india.js": 720,
	"./philippines": 721,
	"./philippines.js": 721,
	"./portuguese/brazil": 722,
	"./portuguese/brazil.js": 722,
	"./southafrica": 724,
	"./southafrica.js": 724,
	"./spanish/argentina": 725,
	"./spanish/argentina.js": 725,
	"./spanish/chile": 726,
	"./spanish/chile.js": 726,
	"./spanish/colombia": 727,
	"./spanish/colombia.js": 727,
	"./spanish/dominicanrepublic": 728,
	"./spanish/dominicanrepublic.js": 728,
	"./spanish/ecuador": 729,
	"./spanish/ecuador.js": 729,
	"./spanish/guatemala": 730,
	"./spanish/guatemala.js": 730,
	"./spanish/mexico": 731,
	"./spanish/mexico.js": 731,
	"./spanish/panama": 732,
	"./spanish/panama.js": 732,
	"./spanish/peru": 733,
	"./spanish/peru.js": 733,
	"./spanish/spain": 734,
	"./spanish/spain.js": 734,
	"./spanish/unitedstates": 735,
	"./spanish/unitedstates.js": 735,
	"./spanish/uruguay": 736,
	"./spanish/uruguay.js": 736,
	"./spanish/venezuela": 737,
	"./spanish/venezuela.js": 737,
	"./taboola": 717,
	"./taboola.js": 717,
	"./taboolaDefaults": 705,
	"./taboolaDefaults.js": 705,
	"./unitedkingdom": 738,
	"./unitedkingdom.js": 738,
	"./unitedstates": 739,
	"./unitedstates.js": 739
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;



//////////////////
// WEBPACK FOOTER
// ../app/lib/utils/editions/config ^\.\/.*$
// module id = 715
// module chunks = 0